import { useQuery } from "@tanstack/react-query";

import {
  TicketsListResponse,
  TicketSummary,
  type TicketsListQuery,
} from "@oracus/shared/api/tickets";

import { apiClient } from "./client.ts";

export function useTickets(query: TicketsListQuery = {}) {
  const params = new URLSearchParams();
  if (query.type) params.set("type", query.type);
  if (query.status) params.set("status", query.status);
  if (query.limit) params.set("limit", String(query.limit));
  const qs = params.toString();

  return useQuery({
    queryKey: ["tickets", query],
    queryFn: () =>
      apiClient.get(
        `/api/tickets${qs ? `?${qs}` : ""}`,
        TicketsListResponse,
      ),
  });
}

export function useTicket(id: string | null) {
  return useQuery({
    queryKey: ["ticket", id],
    queryFn: () =>
      apiClient.get(
        `/api/tickets/${encodeURIComponent(id!)}`,
        TicketSummary,
      ),
    enabled: !!id,
  });
}
